import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import useAlert from '../../Alerts/useAlert';
import usePrivileges from '../../Auth/usePrivileges';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import ConfirmationDialog from '../../Dialogs/ConfirmationDialog';

interface BulkDeleteButtonProps {
    lotIds: Array<number>,
    hidden: boolean,
    setSelectedLots: Dispatch<SetStateAction<Array<number>>>,
    refreshLotList: () => void
}

function BulkDeleteButton({ lotIds, hidden = false, setSelectedLots, refreshLotList }: BulkDeleteButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { admin } = usePrivileges();

    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const onClick = () => {
        setShowConfirmationDialog(true);
    };

    const bulkDelete = async () => {
        fetchDataAuthenticated("api/v1/lots/bulkDelete", "POST", JSON.stringify(lotIds))
            .then(async response => {
                setAlert("success", "Bulk Delete", `Deleting lots...`);
                if (response.ok) {
                    let messageArray = JSON.parse(await response.text());
                    if (messageArray.length > 0) {
                        setAlert("danger", "Error", "Failed to delete lots " + messageArray.join(','));
                    }
                    setSelectedLots([]);
                    refreshLotList();
                } else {
                    let message = await response.text();
                    throw new Error(`Failed to delete lots. ${message}`);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            });
    };

    return (
        <>
            <Button variant="secondary"
                hidden={hidden || !admin}
                onClick={onClick}>
                <FontAwesomeIcon icon={faTrash} className="me-1" />
                {t('LotList.DeleteSelected')}
            </Button>
            <ConfirmationDialog showDialog={showConfirmationDialog} closeDialog={() => setShowConfirmationDialog(false)} onOk={bulkDelete}>
                <p>Are you sure you want to delete the selected lots?</p>
            </ConfirmationDialog>
        </>
    );
}

export default BulkDeleteButton;